import Curriculums from "../../Components/Curriculums";
export default function REV() {
  return (
    <>
      <Curriculums />
    </>
  );
}
